"use client";

import { useRuntimeConfig } from "@lib/env";
import type { StoreCustomer } from "@medusajs/types";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import smartlookClient from "smartlook-client";

export default function SmartlookProvider({ customer }: { customer: StoreCustomer | null }) {
  const pathname = usePathname();
  const { config, loading } = useRuntimeConfig();

  useEffect(() => {
    if (loading || !config.NEXT_PUBLIC_SMARTLOOK_KEY) return;

    if (typeof window !== "undefined") {
      smartlookClient.init(config.NEXT_PUBLIC_SMARTLOOK_KEY, {
        region: "eu",
      });
      smartlookClient.record({
        numbers: true,
        forms: true,
        ips: true,
        emails: true,
      });
      if (customer?.id) {
        smartlookClient.identify(customer.id, {
          email: customer.email,
        });
      }
    }
  }, [config, loading, customer]);

  useEffect(() => {
    if (!loading) {
      smartlookClient.navigation(pathname);
    }
  }, [pathname, loading]);

  return null;
}
